import { render, staticRenderFns } from "./DeploymentDot.vue?vue&type=template&id=47ec44ff&scoped=true"
import script from "./DeploymentDot.vue?vue&type=script&lang=ts"
export * from "./DeploymentDot.vue?vue&type=script&lang=ts"
import style0 from "./DeploymentDot.vue?vue&type=style&index=0&id=47ec44ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec44ff",
  null
  
)

export default component.exports